import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "bxs:up-arrow" }, [
      _createElementVNode("path", {
        id: "Vector",
        d: "M1.25284 7.91854H8.75284C8.82878 7.9183 8.90321 7.89736 8.96812 7.85797C9.03304 7.81857 9.08599 7.76222 9.12126 7.69498C9.15653 7.62773 9.1728 7.55214 9.1683 7.47634C9.16381 7.40054 9.13873 7.3274 9.09576 7.26479L5.34576 1.84812C5.19034 1.62354 4.81618 1.62354 4.66034 1.84812L0.910343 7.26479C0.866937 7.32727 0.841482 7.40044 0.836745 7.47637C0.832008 7.5523 0.84817 7.62807 0.883474 7.69546C0.918778 7.76285 0.971875 7.81927 1.03699 7.8586C1.10212 7.89793 1.17677 7.91866 1.25284 7.91854Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }